export const WS_PROTOCOLS = 'aws.iot.securetunneling-3.0';
